/**
 * What every client's messaging sent, delivered and cost — by client first,
 * because the question staff ask is "who is sending, and are they paying for
 * what fails". A client's own figures are on its page, under Usage.
 */

import { PageHeader, UsageReport, todayISO, useCan } from '@connect/web-shared';

import { messagingKeys } from './types';

export function MessagingUsagePage() {
  const canExport = useCan('messaging.usage.export');
  return (
    <div className="space-y-4">
      <PageHeader
        title="Messaging usage"
        description="Messages, delivery and cost across every client, from their gateways' own reports."
        breadcrumbs={[{ label: 'Insight' }, { label: 'Messaging usage' }]}
      />
      <UsageReport
        basePath="/messaging/reports"
        queryKey={messagingKeys.allReports}
        groups={['client', 'day', 'template', 'sender']}
        canExport={canExport}
        today={todayISO()}
      />
    </div>
  );
}
